import React from 'react';
import { Button } from '@/components/ui/button';

const EmptyCalendar = ({ containsService, onRegister }) => {
  return (
    <div className="bg-[#ffffff] rounded-2xl p-3 md:p-5 select-none flex flex-col items-center min-h-[100px] md:min-h-[400px] mt-3">
      <p className="text-center text-[#1F4B81] text-lg md:text-xl font-semibold mb-3">
        Dėl datos ir laiko teirautis telefonu 1811
      </p>
    </div>
  );
};

export default EmptyCalendar;
